import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-dismiss"
export default class extends Controller {
  static values = {
    timeout: { type: Number, default: 3000 }
  }

  connect() {
    // Click to dismiss immediately
    this.clickHandler = () => this.dismiss()
    this.element.addEventListener("click", this.clickHandler)

    // Auto dismiss after timeout
    this.timer = setTimeout(() => this.dismiss(), this.timeoutValue)

    // Initial styles for smooth entry if not already present
    this.element.style.willChange = "opacity, transform"
    this.element.style.transition = "opacity 200ms ease-out, transform 200ms ease-out"
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("click", this.clickHandler)
  }

  dismiss() {
    if (this._dismissed) return
    this._dismissed = true
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-6px)"
    setTimeout(() => {
      this.element.remove()
    }, 220)
  }
}
